import { colors } from "@minuthq/meatball-ui-react"

import { THome } from "src/data/homes/types/homeTypes"
import OccupancyFilledIcon from "src/ui/icons/occupancy-detection-filled.svg"
import { SVGProps } from "src/utils/tsUtil"

/**
 * PresenceAndOccupancyIcon
 * Icon that shows the current state of presence detection (motion automation) and crowd detection (occupancy).
 * Follows the same pattern as other monitoring icons (WaterLeakDetectionIcon, SmokingDetectionIcon).
 * @example <PresenceAndOccupancyIcon occupancyActive={true} occupancyStatus="crowd_detected" motionAutomationState="enabled" />
 */
export function PresenceAndOccupancyIcon({
  occupancy,
  motionAutomation,
  iconProps,
}: {
  occupancy?: THome["occupancy"]
  motionAutomation?: THome["motion_automation"]
  iconProps?: SVGProps
}) {
  // Determine if either feature is enabled
  const isOccupancyEnabled = occupancy?.active === true
  const isMotionAutomationEnabled = motionAutomation?.mode === "enabled"
  const isAnyFeatureEnabled = isOccupancyEnabled || isMotionAutomationEnabled

  if (isAnyFeatureEnabled) {
    // If occupancy / presence is active and has a crowd detected status, show error colors
    if (
      (isOccupancyEnabled && occupancy?.status === "crowd_detected") ||
      (isMotionAutomationEnabled && motionAutomation?.has_unexpected_presence)
    ) {
      return (
        <OccupancyFilledIcon
          fill={colors.systemErrorLight}
          color={colors.systemErrorDark}
          {...iconProps}
        />
      )
    }

    // Any feature enabled - show info colors
    return (
      <OccupancyFilledIcon
        fill={colors.systemInfoLight}
        color={colors.systemInfoDark}
        {...iconProps}
      />
    )
  }

  // Neither feature enabled - show neutral colors
  return (
    <OccupancyFilledIcon
      fill={colors.neutralDark}
      color={colors.neutralDark2}
      {...iconProps}
    />
  )
}
